const rootActions = {
  SET_CURRENT_CATEGORY_ACTION: ({commit, state}, payload) => {
    commit('SET_CURRENT_CATEGORY_MUTATION', payload);
  },
};

export default rootActions;
